<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      entityConfig: {},
    };
  },
  mounted() {
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
      this.createCookieBot();
      this.createHeadScriptElement();
      this.createFooterScriptElement();
      document.title = this.entityConfig.nameSite;
      let link = document.querySelector("link[rel~='icon']");    
      link.href = this.entityConfig.faviconSite;
    }, 1000);
  },
  methods: {
    createCookieBot: function() {
      if (this.entityConfig.cookieBot) {
        let cbElement = document.createElement('script');
        cbElement.type = 'text/javascript';
        cbElement.id = 'Cookiebot';
        cbElement.src = 'https://consent.cookiebot.com/uc.js';
        cbElement.dataset.cbid = this.entityConfig.cookieBot.cbid;
        cbElement.dataset.blockingmode = 'auto';
        document.head.appendChild(cbElement);
  
        let cookieBotTypes = ['statistics', 'marketing', 'preferences'];
  
        cookieBotTypes.map(type => {
          this.createCookieBootScriptElement(type);
        });
      }
    },
    createCookieBootScriptElement: function(type) {
      if (this.entityConfig.cookieBot[type])  {
        let scriptElm = document.createElement('script');
        scriptElm.type = "text/plain";
        scriptElm.src = this.entityConfig.cookieBot[type];
        scriptElm.dataset.cookieconsent = type;
        document.head.appendChild(scriptElm);
      }
    },
    createHeadScriptElement() {
      if (this.entityConfig.headerScriptUrl) {
        let scriptElm = document.createElement('script');
        scriptElm.type = 'text/javascript';
        scriptElm.src = this.entityConfig.headerScriptUrl;
        document.head.appendChild(scriptElm);
      }
    },
    createFooterScriptElement() {
      if (this.entityConfig.footerScriptUrl) {
        let scriptElm = document.createElement('script');
        scriptElm.type = 'text/javascript';
        scriptElm.src = this.entityConfig.footerScriptUrl;
        document.querySelector('footer').appendChild(scriptElm);
      }
    }
  }
};
</script>
